import React from "react"
import { MenuItem, Stack, Typography } from "@mui/material"
import Checkbox from "../Checkbox"
import { RuleName, useStyles } from "./styles"
import { OptionHandler } from "./DropdownMenuItem"
import { FaIcon } from "../../../../mp-core/icons"

interface Props {
  label: string | React.ReactNode
  selected: boolean
  action?: OptionHandler
  disabled?: boolean
  classes?: Partial<Record<RuleName, string>>
  ["data-automation-id"]?: string
}

export const CollapsibleMenuItem: React.FC<Props> = ({
  label,
  selected,
  action,
  disabled = false,
  classes: outerClasses,
  ["data-automation-id"]: dataAutomationId
}) => {
  const { classes, cx } = useStyles()

  return (
    <MenuItem
      tabIndex={0}
      className={cx(
        classes.menuItem,
        classes.collapsibleMenuItem,
        outerClasses?.menuItem,
        outerClasses?.collapsibleMenuItem,
        classes.menuItemWithCheckbox,
        {
          [classes.menuItemSelected]: selected,
          ...(outerClasses?.menuItemWithCheckbox && {
            [outerClasses.menuItemWithCheckbox]: true
          }),
          ...(outerClasses?.menuItemSelected && {
            [outerClasses.menuItemSelected]: selected
          })
        }
      )}
      disabled={disabled}
      data-automation-id={dataAutomationId}
      disableRipple
      onClick={action}
      onKeyDown={e => e.stopPropagation()}
    >
      <Stack direction="row" spacing={1} alignItems="center">
        <FaIcon
          solid
          name="dash"
          className={cx(
            classes.collapsibleMinusIcon,
            outerClasses?.collapsibleMinusIcon
          )}
        />
        <Checkbox checked={selected} />
        <Typography ml={2} variant="citation">
          {label}
        </Typography>
      </Stack>
    </MenuItem>
  )
}
